import React from 'react';

import { roundToTwoDecimalPlaces } from '@/helpers/utils/numberHelpers';
import { useGetPetQuizCountQuery } from '@/store/api/dashboard';

import ReportsLoader from '../Reports/CustomerDetailModal/ReportsLoader';
import CounterBox from './Components/CounterBox';

const PetQuizCount = () => {
  const { data, isLoading, isFetching } = useGetPetQuizCountQuery();
  return (
    <div className="v2-shadow-md v2-p-[24px] md:v2-p-[24px] sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
      <div className="v2-pb-5 v2-border-b v2-border-[#E5E5E5] v2-mb-5">
        <h2 className="v2-text-[#333333] v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl v2-text-center">
          Pet Quiz Count
        </h2>
      </div>
      {isLoading || isFetching ? (
        <div className="v2-h-[130px] v2-flex v2-justify-center v2-items-center">
          <ReportsLoader />
        </div>
      ) : (
        <div className="v2-flex v2-gap-3">
          <CounterBox label="Pet Quiz Count" count={data?.data?.petProfileCount ?? 0} />
          <CounterBox
            label="Pet Quiz Order Volume"
            count={roundToTwoDecimalPlaces(data?.data?.petProfileOrderVolume) ?? 0.0}
          />
        </div>
      )}
    </div>
  );
};

export default PetQuizCount;
